import { render } from "./Emcee.vue?vue&type=template&id=3830da84&scoped=true"
import script from "./Emcee.vue?vue&type=script&lang=js"
export * from "./Emcee.vue?vue&type=script&lang=js"

import "./Emcee.vue?vue&type=style&index=0&id=3830da84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3830da84"]])

export default __exports__